<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon>Realizar Pagos Proveedor</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta Corriente Proveedor</span>
      <span> /</span>
      <span>Realizar Pagos Proveedor</span>
    </p>
  </div>
</div>
<!-- Heading -->
<app-cc-proveedor-pagos-cabecera (eventoIniciaPago)="iniciaProcesoPago($event)"></app-cc-proveedor-pagos-cabecera>
<!-- Cabecera de botones -->

<app-cc-proveedor-pagos-listas (eventoConformePago)="iniciaConforme($event);"  [rutProveedorSel]="rutProveedorSel"></app-cc-proveedor-pagos-listas>


<!--Panel de listado de pagos-->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <div
      class="row filtros-header"
      style="
        border-bottom: 1px solid #dee2e6;
        justify-content: space-between;
        align-items: center;
      "
    >
      <h4>Formas de pago</h4>
    </div>

    <div class="table-responsive mt-1">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox (change)="checkAllChange($event)" [(ngModel)]="checkAll"></mdb-checkbox>
            </th>
            <th scope="col">Tipo de pago</th>
            <th scope="col">Nro. Doc. Referente</th>
            <th scope="col" class="text-right">Monto</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pag of listaFormaPago">
            <td><mdb-checkbox [(ngModel)]="pag.seleccionado"></mdb-checkbox></td>
            <td>{{pag.tipo_pago_nombre}}</td>
            <td *ngIf="pag.tipo_pago_codigo != 2 && pag.numero_doc > 0">{{pag.numero_doc}}</td>
            <td *ngIf="pag.tipo_pago_codigo == 2 ||  pag.numero_doc == 0"></td>
            <td class="text-right">{{pag.monto | numerico}}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="3">
              <strong>Total forma de pago</strong>
            </td>
            <td class="text-right"><strong>{{totalFormaPago | numerico}}</strong></td>
          </tr>
          <tr>
            <td class="text-right" colspan="3">
              <strong>Saldo</strong>
            </td>
            <td class="text-right"><strong>$ {{SaldoPago | numerico}}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- FOOTER -->
  <div
    class="card-footer text-muted filtros-footer"
    style="border-top: 1px solid #dee2e6"
  >
    <button mdbBtn type="button" size="sm" color="warning" mdbWavesEffect [disabled]="!conformePago"
    (click)="eliminaPago()">
    <span *ngIf="countSelect === 0">Eliminar</span>
    <span *ngIf="countSelect > 0"> Eliminar {{ countSelect }} seleccionados</span>
    </button>
    <div></div>
  </div>
</div>
<!--Tabs panel de pagos-->
<div class="row">
  <div class="col p-0">
    <!-- Nav Tabs -->
    <mdb-tabset
      #staticTabs
      [buttonClass]="'md-tabs tabs-3 text-uppercase indigo'"
      [contentClass]="'p-0'"
      class="nav-reglas p-0"
    >
      <!--Panel 1-->
      <mdb-tab heading="Cheque">
        <form [formGroup]="frmCheque">
          <div class="card mt-2 mb-2 wow">
            <div class="filtros card-body justify-content-between pt-0 pb-0">
              <div class="row filtros-body align-items-center mt-2">
                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="nroDocumento"
                      class="form-control"
                      placeholder="Nro. Documento"
                      formControlName="nroDocumento"
                      #nroDocumento
                    />
                    <label for="nroDocumento">Nro. Documento</label>
                    <div *ngIf="
                            frmCheque.get('nroDocumento').invalid &&
                            (submittedCheque)
                        ">
                        <mdb-error
                            *ngIf="frmCheque.get('nroDocumento').hasError('required') || frmCheque.get('nroDocumento').hasError('min')">
                            Ingrese nro. docto.
                        </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="montoEfectivo"
                      class="form-control"
                      placeholder="Monto"
                      formControlName="montoEfectivo"
                      [(ngModel)]="MontoPagar"
                      monto
                      #montoEfectivo
                    />
                    <label for="montoEfectivo">Monto</label>
                    <div *ngIf="
                            frmCheque.get('montoEfectivo').invalid &&
                            (submittedCheque)
                        ">
                        <mdb-error
                            *ngIf="frmCheque.get('montoEfectivo').hasError('required') || frmCheque.get('montoEfectivo').hasError('min')">
                            Debe ingresar el monto
                        </mdb-error>
                    </div>
                  </div>
                </div>

                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <mdb-date-picker
                      [inline]="true"
                      name="fechaDesde"
                      [placeholder]="'Fecha'"
                      required
                      formControlName="fechaDesde"
                    ></mdb-date-picker>
                  </div>
                  <div *ngIf="
                            frmCheque.get('fechaDesde').invalid &&
                            (submittedCheque)
                        ">
                        <mdb-error
                            *ngIf="frmCheque.get('fechaDesde').hasError('required') || frmCheque.get('fechaDesde').hasError('min')">
                            Debe ingresar la fecha
                        </mdb-error>
                    </div>
                </div>

                <!-- <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <mdb-select
                      label="Bancos"
                      [options]="optionsDatosBancos"
                      [multiple]="false"
                      formControlName="banco"
                      placeholder="Bancos"
                      [filterEnabled]="true"
                    ></mdb-select>
                  </div>
                  <div *ngIf="
                            frmCheque.get('banco').invalid &&
                            (submittedCheque)
                        ">
                        <mdb-error
                            *ngIf="frmCheque.get('banco').hasError('required') || frmCheque.get('banco').hasError('min')">
                            Debe ingresar el banco
                        </mdb-error>
                    </div>
                </div> -->

                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <mdb-select
                      label="Bancos"
                      placeholder="Bancos"
                      formControlName="banco"
                      [options]="optionsDatosBancosEmpresa"
                      [multiple]="false"
                      [filterEnabled]="true"
                    ></mdb-select>
                  </div>
                  <div *ngIf="
                  frmCheque.get('banco').invalid &&
                  (submittedCheque)
                  ">
                <mdb-error
                    *ngIf="frmCheque.get('banco').hasError('required') || frmCheque.get('banco').hasError('min')">
                    Ingrese banco
                </mdb-error>
                </div>
              </div>


                <!-- OCULTAR -->
                <!-- <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <input
                    value=""
                    type="text"
                    id="nroCuenta"
                    class="form-control"
                    placeholder="Nro. de cuenta"
                    formControlName="nroCuenta"
                    required
                    #nroCuenta
                  />
                    <label for="nroCuenta">Nro. de cuenta</label>
                    <div *ngIf="
                    frmCheque.get('banco').invalid &&
                    (submittedCheque)
                ">
                <mdb-error
                    *ngIf="frmCheque.get('nroCuenta').hasError('required') || frmCheque.get('nroCuenta').hasError('min')">
                    Debe ingresar el nro de cuenta
                </mdb-error>
            </div>
                  </div>
                </div> -->

                <!-- INGRESAR NRO DE CUENTA -->
                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <mdb-select
                    [options]="optionsDatosCuenta"
                    [multiple]="false"
                    placeholder="Nro. Cuenta"
                    [filterEnabled]="true"
                    formControlName="nroCuenta"
                    #nroCuenta
                  ></mdb-select>
                    <label for="nroCuenta">Nro. de Cuenta</label>
                  </div>
                  <div *ngIf="
                  frmCheque.get('nroCuenta').invalid &&
                  (submittedCheque)
              ">
                <mdb-error
                    *ngIf="frmCheque.get('nroCuenta').hasError('required') || frmCheque.get('nroCuenta').hasError('min')">
                    Ingrese nro. de cuenta
                </mdb-error>
              </div>
              </div>

              </div>

              <div
                class="row filtros-footer"
                style="border-top: 1px solid #dee2e6"
              >
                <div></div>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="secondary"
                  size="sm"
                  (click)="agregaPagoCheque()"
                  [disabled]="!conformePago"
                  mdbWavesEffect
                >
                  Agregar
                </button>
              </div>
            </div>
          </div>
        </form>

      </mdb-tab>

      <!--Panel 2-->
      <mdb-tab heading="Transferencia">
        <form [formGroup]="frmTransferencia">
          <div class="card mt-3 mb-2 wow">
            <div class="filtros card-body justify-content-between pt-0 pb-0">
              <div class="row filtros-body align-items-center mt-2">
                <!-- <div class="col" style="max-width: 150px;">
                  <div class="md-form">
                      <input value="" type="text" id="nroDocumento" class="form-control"
                          placeholder="Nro. Documento" #nroDocumento
                          formControlName="nroDocumento" onlyNumbers />
                      <label for="nroDocumento">N° Doc.</label>
                  </div>
                  <div *ngIf="
                  frmTransferencia.get('nroDocumento').invalid &&
                  (submittedTransferencia)
              ">
              <mdb-error
                  *ngIf="frmTransferencia.get('nroDocumento').hasError('required') || frmTransferencia.get('nroDocumento').hasError('min')">
                  Ingrese nro. docto.
              </mdb-error>
          </div>
              </div> -->
                <div class="col" style="max-width: 150px;">
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="montoEfectivo"
                      class="form-control"
                      placeholder="Monto"
                      formControlName="montoEfectivo"
                      [(ngModel)]="MontoPagar"
                      monto
                      #montoEfectivo
                    />
                    <label for="montoEfectivo">Monto</label>
                      <div *ngIf="
                      frmTransferencia.get('montoEfectivo').invalid &&
                      (submittedTransferencia)
                  ">
                    <mdb-error
                        *ngIf="frmTransferencia.get('montoEfectivo').hasError('required') || frmTransferencia.get('montoEfectivo').hasError('min')">
                        Ingrese monto
                    </mdb-error>
                  </div>
                  </div>
                </div>

                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <mdb-date-picker
                      [inline]="true"
                      name="fechaDesde"
                      [placeholder]="'Fecha'"
                      required
                      formControlName="fechaDesde"
                    ></mdb-date-picker>
                  </div>
                  <div *ngIf="
                  frmTransferencia.get('fechaDesde').invalid &&
                  (submittedTransferencia)
              ">
                <mdb-error
                    *ngIf="frmTransferencia.get('fechaDesde').hasError('required') || frmTransferencia.get('fechaDesde').hasError('min')">
                    Ingrese fecha
                </mdb-error>
              </div>
                </div>


              <!-- <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <mdb-select
                      label="Bancos"
                      [options]="optionsDatosBancosEmpresa"
                      [multiple]="false"
                      placeholder="Bancos"
                      [filterEnabled]="true"
                      formControlName="banco"
                    ></mdb-select>
                  </div>
                  <div *ngIf="
                  frmTransferencia.get('banco').invalid &&
                  (submittedTransferencia)
                  ">
                <mdb-error
                    *ngIf="frmTransferencia.get('banco').hasError('required') || frmTransferencia.get('banco').hasError('min')">
                    Ingrese banco
                </mdb-error>
                </div>
              </div> -->

                 <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <mdb-select
                      label="Bancos"
                      [options]="optionsDatosBancos"
                      [multiple]="false"
                      formControlName="banco"
                      placeholder="Bancos"
                      [filterEnabled]="true"
                    ></mdb-select>
                  </div>
                  <div *ngIf="
                  frmTransferencia.get('banco').invalid &&
                            (submittedTransferencia)
                        ">
                        <mdb-error
                            *ngIf="frmTransferencia.get('banco').hasError('required') || frmTransferencia.get('banco').hasError('min')">
                            Debe ingresar el banco
                        </mdb-error>
                    </div>
                </div>


              <!-- OCULTAR -->
              <!-- <div class="col" style="max-width: 300px">
                <div class="md-form">
                  <mdb-select
                  [options]="optionsDatosCuenta"
                  [multiple]="false"
                  placeholder="Nro. Cuenta"
                  [filterEnabled]="true"
                  formControlName="nroCuenta"
                  #nroCuenta
                ></mdb-select>
                  <label for="nroCuenta">Nro. de Cuenta</label>
                </div>
                <div *ngIf="
                frmTransferencia.get('nroCuenta').invalid &&
                (submittedTransferencia)
            ">
              <mdb-error
                  *ngIf="frmTransferencia.get('nroCuenta').hasError('required') || frmTransferencia.get('nroCuenta').hasError('min')">
                  Ingrese nro. de cuenta
              </mdb-error>
            </div>
            </div> -->

            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <input
                value=""
                type="text"
                id="nroCuenta"
                class="form-control"
                placeholder="Nro. de cuenta"
                formControlName="nroCuenta"
                required
                #nroCuenta
              />
                <label for="nroCuenta">Nro. de cuenta</label>
                <div *ngIf="
                frmTransferencia.get('banco').invalid &&
                (submittedCheque)
            ">
            <mdb-error
                *ngIf="frmTransferencia.get('nroCuenta').hasError('required') || frmTransferencia.get('nroCuenta').hasError('min')">
                Debe ingresar el nro de cuenta
            </mdb-error>
        </div>
              </div>
            </div>


              </div>
            </div>
            <div
            class="card-footer text-muted filtros-footer"
            style="border-top: 1px solid #dee2e6"
          >
            <div></div>
            <button
              mdbBtn
              type="button"
              size="sm"
              color="secondary"
              size="sm"
              mdbWavesEffect
              [disabled]="!conformePago"
              (click)="agregaPagoTrf()"
            >
              Agregar
            </button>
          </div>
          </div>
        </form>

      </mdb-tab>

      <!--Panel 3-->
      <mdb-tab heading="Efectivo">
        <form [formGroup]="frmEfectivo">
          <div class="card mt-2 mb-2 wow">
            <div class="filtros card-body justify-content-between pt-0 pb-0">
              <div class="row filtros-body align-items-center mt-2">
                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="montoEfectivo"
                      class="form-control"
                      placeholder="Monto"
                      required
                      formControlName="montoEfectivo"
                      [(ngModel)]="MontoPagar"
                      monto
                      #montoEfectivo
                    />
                    <label for="montoEfectivo">Monto</label>
                    <div *ngIf="
                    frmEfectivo.get('montoEfectivo').invalid &&
                    (submittedEfectivo)
                ">
                  <mdb-error
                      *ngIf="frmEfectivo.get('montoEfectivo').hasError('required') || frmEfectivo.get('montoEfectivo').hasError('min')">
                      Ingrese monto
                  </mdb-error>
                </div>
                  </div>
                </div>
              </div>
              <div
                class="row filtros-footer"
                style="border-top: 1px solid #dee2e6"
              >
                <div></div>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="secondary"
                  size="sm"
                  mdbWavesEffect
                  [disabled]="!conformePago"
                  (click)="agregaPagoEfectivo()"
                >
                  Agregar
                </button>
              </div>
            </div>
          </div>
        </form>

      </mdb-tab>

      <!--Panel 4-->
      <mdb-tab heading="Depósito">
        <form [formGroup]="frmDeposito">
          <div class="card mt-2 mb-2 wow">
            <div class="filtros card-body justify-content-between pt-0 pb-0">
              <div class="row filtros-body align-items-center mt-2">
                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="nroDeposito"
                      class="form-control"
                      placeholder="Nro. Depósito"
                      formControlName="nroDeposito"
                      required
                      #nroDeposito
                    />
                    <label for="nroDeposito">Nro. Depósito</label>
                    <div *ngIf="
                    frmDeposito.get('nroDeposito').invalid &&
                    (submittedDeposito)
                ">
                  <mdb-error
                      *ngIf="frmDeposito.get('nroDeposito').hasError('required') || frmDeposito.get('nroDeposito').hasError('min')">
                      Ingrese nro. depósito
                  </mdb-error>
                </div>
                  </div>
                </div>
                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <input
                      value=""
                      type="text"
                      id="montoEfectivo"
                      class="form-control"
                      placeholder="Monto"
                      required
                      formControlName="montoEfectivo"
                      [(ngModel)]="MontoPagar"
                      monto
                      #montoEfectivo
                    />
                    <label for="montoEfectivo">Monto</label>
                    <div *ngIf="
                    frmDeposito.get('montoEfectivo').invalid &&
                    (submittedDeposito)
                ">
                  <mdb-error
                      *ngIf="frmDeposito.get('montoEfectivo').hasError('required') || frmDeposito.get('montoEfectivo').hasError('min')">
                      Ingrese monto
                  </mdb-error>
                </div>
                  </div>
                </div>

                <div class="col" style="max-width: 200px">
                  <div class="md-form">
                    <mdb-date-picker
                      [inline]="true"
                      name="fechaDesde"
                      [placeholder]="'Fecha'"
                      required
                      formControlName="fechaDesde"
                    ></mdb-date-picker>
                  </div>
                  <div *ngIf="
                  frmDeposito.get('fechaDesde').invalid &&
                  (submittedDeposito)
              ">
                <mdb-error
                    *ngIf="frmDeposito.get('fechaDesde').hasError('required') || frmDeposito.get('fechaDesde').hasError('min')">
                    Ingrese fecha
                </mdb-error>
              </div>
                </div>
                <!-- <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <mdb-select
                      label="Bancos"
                      [options]="optionsDatosBancosEmpresa"
                      [multiple]="false"
                      placeholder="Bancos"
                      [filterEnabled]="true"
                      formControlName="bancoDeposito"
                      #banco
                    ></mdb-select>
                  </div>
                  <div *ngIf="
                  frmDeposito.get('bancoDeposito').invalid &&
                  (submittedDeposito)
              ">
                <mdb-error
                    *ngIf="frmDeposito.get('bancoDeposito').hasError('required') || frmDeposito.get('bancoDeposito').hasError('min')">
                    Ingrese banco
                </mdb-error>
              </div>
                </div> -->



                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <mdb-select
                      label="Bancos"
                      [options]="optionsDatosBancos"
                      [multiple]="false"
                      formControlName="bancoDeposito"
                      placeholder="Bancos"
                      [filterEnabled]="true"
                    ></mdb-select>
                  </div>
                  <div *ngIf="
                  frmDeposito.get('bancoDeposito').invalid &&
                            (submittedDeposito)
                        ">
                        <mdb-error
                            *ngIf="frmDeposito.get('bancoDeposito').hasError('required') || frmDeposito.get('bancoDeposito').hasError('min')">
                            Debe ingresar el banco
                        </mdb-error>
                    </div>
                </div>


                <!-- <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <mdb-select
                      label="Nro. de Cuenta"
                      [options]="optionsDatosCuentaTrans"
                      [multiple]="false"
                      placeholder="Nro. Cuenta"
                      [filterEnabled]="true"
                      required
                      formControlName="nroCuentaDeposito"
                      #nroCuenta
                    ></mdb-select>


                    <div *ngIf="
                    frmDeposito.get('bancoDeposito').invalid &&
                    (submittedDeposito)
                ">
                  <mdb-error
                      *ngIf="frmDeposito.get('nroCuentaDeposito').hasError('required') || frmDeposito.get('nroCuentaDeposito').hasError('min')">
                      Ingrese nro. cuenta depósito
                  </mdb-error>
                </div>
                  </div>
                </div> -->

                <div class="col" style="max-width: 300px">
                  <div class="md-form">
                    <input
                    value=""
                    type="text"
                    id="nroCuenta"
                    class="form-control"
                    placeholder="Nro. de cuenta"
                    formControlName="nroCuentaDeposito"
                    required
                    #nroCuenta
                  />
                    <label for="nroCuenta">Nro. de cuenta</label>
                    <div *ngIf="
                    frmDeposito.get('bancoDeposito').invalid &&
                    (submittedDeposito)
                ">
                <mdb-error
                    *ngIf="frmDeposito.get('nroCuentaDeposito').hasError('required') || frmDeposito.get('nroCuentaDeposito').hasError('min')">
                    Debe ingresar el nro de cuenta
                </mdb-error>
            </div>
                  </div>
                </div>


              </div>

              <div
                class="row filtros-footer"
                style="border-top: 1px solid #dee2e6"
              >
                <div></div>
                <button
                  mdbBtn
                  type="button"
                  size="sm"
                  color="secondary"
                  size="sm"
                  mdbWavesEffect
                  (click)="agregaPagoDeposito()"
                  [disabled]="!conformePago"
                >
                  Agregar
                </button>
              </div>
            </div>
          </div>
        </form>

      </mdb-tab>
    </mdb-tabset>
  </div>
</div>
<!--Boton pagar-->
<div class="card mb-2 wow">
  <div
    class="card-body d-sm-flex p-1 justify-content-end align-items-center"
  >
    <button
      mdbBtn
      type="button"
      color="default"
      class="btn mr-2"
      (click)="validarLimpiar()"
      mdbWavesEffect>
      Cancelar
    </button>
    <button
      mdbBtn
      type="button"
      color="success"
      (click)="showModalConfirm()"
      mdbWavesEffect
      class="btn"
      [disabled]="!habilitarPago">
      Pagar
    </button>
  </div>
</div>
<!-- MODAL confirm -->
<app-modal-confirm #confirmarPagoModal title="Confirmar Pago" contentText="¿Desea confirmar el pago a proveedor?">
</app-modal-confirm>
<app-modal-confirm #limpiarModal title="Limpiar datos" contentText="¿Desea limpiar los datos ingresados?">
</app-modal-confirm>
